<template>
  <div>
    <div class="form-row">
       <div class="form-group no-label col-md-6">
        <label>ระยะเวลาในการค้ำประกัน</label>
      </div>
    </div>
    <div class="form-row div-valign">
      <div class="form-group no-label col-md-6">
        <div class="">
          <b-form-radio
            v-model="extperiodType"
            v-bind:value=2
            name="extperiodType"
            v-validate="{required:true}"
          >มีกำหนดระยะเวลา</b-form-radio>

          <div class="period">
            <vue-numeric
              separator=","
              :empty-value="0"
              v-model="periodAmt"
              name="periodAmt"
              id="periodAmt"
              ref="periodAmt"
              class="form-control"
              placeholder="กรุณากรอกระยะเวลา"
              :disabled="this.extperiodType !== 2"
              @blur="getPeriod('num')"
              :class="{'input': true, 'is-danger': errors.has('periodAmt')}"
            ></vue-numeric>
            <span
              v-show="errors.has('periodAmt')"
              class="help is-danger"
            >ระยะเวลา ไม่ถูกต้อง</span>                      
            <select class="form-control" name="periodUnit" id="periodUnit" ref="periodUnit" v-model="periodUnit" 
            :class="{'input': true, 'is-danger': errors.has('periodUnit') }"
            @change="getPeriod('unit')"
            :disabled="this.extperiodType !== 2">
              <option value="">เลือก</option>
              <option v-for="unit in periodUnitList" :value="unit.id" :key="unit.id">
                {{ unit.name }}
              </option>
            </select>                      
          </div>
        </div>
      </div>              
      <div class="form-group no-label col-md-3"> 
        <div class="form-row date-pick">
          <label>ตั้งแต่วันที่</label>
          <date-picker
            v-model="extperiodStartDate1"
            name="extperiodStartDate1"
            ref="extperiodStartDate1"
            lang="th"
            format="DD/MM/YYYY"
            :disabled="true"
            :not-after="this.extperiodEndDate"
            :not-before="this.tmpStartDate1"
            placeholder
            v-validate="{ required: this.extperiodType ===2 }"
            data-vv-as="ตั้งแต่วันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodStartDate1') }"
            width="140px"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodStartDate1')}"
          >{{ errors.first('extperiodStartDate1') }}</span>
        </div>
      </div>         
      <div class="form-group no-label col-md-3">
        <div class="form-row date-pick">
          <label>ถึงวันที่</label>
          <date-picker
            v-model="extperiodEndDate"
            name="extperiodEndDate"
            ref="extperiodEndDate"
            lang="th"
            format="DD/MM/YYYY"
            :defaultValue="this.defaultEndDateValue"
            :disabled="this.extperiodType !== 2"
            :not-before="new Date()>this.extperiodStartDate1?new Date():this.extperiodStartDate1"
            placeholder
            v-validate="{ required: this.extperiodType ===2 }"
            data-vv-as="ถึงวันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodEndDate') }"
            @change="getPeriod('endDate')"
            width="140px"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodEndDate')}"
          >{{ errors.first('extperiodEndDate') }}</span>
        </div>
      </div>             
    </div>

    <div class="form-row div-valign">
      <div class="form-group no-label col-md-3">
        <b-form-radio
          v-model="extperiodType"
          name="extperiodType"
          v-bind:value=1
          v-validate="{required:true}"
        >ไม่มีกำหนดระยะเวลา</b-form-radio>
      </div>

      <div class="form-group no-label col-md-2"><label>ตั้งแต่วันที่</label></div>
      <div class="form-group no-label col-md-3">
        <div class="form-row">
          <date-picker
            v-model="extperiodStartDate2"
            name="extperiodStartDate2"
            ref="extperiodStartDate2"
            lang="th"
            format="DD/MM/YYYY"
            placeholder
            :disabled="true"
            v-validate="{ required: this.extperiodType ===1 }"
            data-vv-as="ตั้งแต่วันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodStartDate2') }"
            width="140px"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodStartDate2')}"
          >{{ errors.first('extperiodStartDate2') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { apiClient } from "@/utils/apiClient";

export default {
  inject: ["$validator"],
  props: ["reqType","oldperiodEndDate"],
  data() {
    return {
      extperiodType: "",
      extperiodStartDate1: "",
      extperiodStartDate2: "",
      extperiodEndDate: "",
      tmpStartDate1:"",
      defaultEndDateValue:this.defaultEndDate(),
      periodAmt: "",
      periodUnit: "",
      periodUnitList: [
        {id: 'dd', name: 'วัน'}, 
        {id: 'mm', name: 'เดือน'}, 
        {id: 'yyyy', name: 'ปี'}
        ],
    };
  },
  mounted() {

    if(typeof this.oldperiodEndDate === 'object'){
      //this.extperiodStartDate1 = this.addDays(this.oldperiodEndDate,1);
      //this.extperiodStartDate2 = this.addDays(this.oldperiodEndDate,1);
      this.tmpStartDate1 = this.extperiodStartDate1;
    }
  },
  methods: {
    getPeriod: function(event){
      return new Promise((resolve, reject) => {
      if(this.periodUnit === ''){
        return;
      }
      if(event === 'endDate'){
        if(this.extperiodStartDate1 === ''){
          return;
        }
        this.loader = this.$loading.show();

        let vperiodStartDate = "-";
        let vperiodEndDate = "-";
        vperiodStartDate = moment(this.extperiodStartDate1).format("DD-MM-YYYY");
        vperiodEndDate = moment(this.extperiodEndDate).format("DD-MM-YYYY");

          apiClient
            .get(
              "/api/home/getPeriodAmtBetweenDates/" + vperiodStartDate+"/"+vperiodEndDate+"/"+this.periodUnit
            )
            .then(resp => {
              this.loader.hide();
              if (resp.data) {
                this.periodAmt = resp.data;
                this.errors.clear();
              }else{
                this.periodAmt = '';
              }
              resolve();
            });

      }else{
        if(this.periodAmt === '' || this.extperiodStartDate1 === ''){
          return;
        }

        let vperiodStartDate = moment(this.extperiodStartDate1).format("DD-MM-YYYY");

        this.loader = this.$loading.show();
          apiClient
            .get(
              "/api/home/getEndDate/" + this.periodAmt+"/"+this.periodUnit+"/"+vperiodStartDate
            )
            .then(resp => {
              this.loader.hide();
              
              if (resp.data !== '') {
                this.extperiodEndDate = moment(resp.data, 'DD/MM/YYYY');
                this.errors.clear();              
              }else{
                this.extperiodEndDate = '';
                this.errors.add({
                  field: 'extperiodEndDate',
                  msg: 'กรุณากรอก ถึงวันที่'
                })
              }
              resolve();
            });
      }
      });      
    },
    defaultEndDate:function(){
      let newDeaultEndDate = new Date();
      if(typeof this.oldperiodEndDate === 'object'){
        newDeaultEndDate = this.addDays(this.oldperiodEndDate,1);        
      }
      return newDeaultEndDate;
    },

    addDays:function(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },

  },
  watch: {
    extperiodType(newval, oldval) {
       if (newval === 1) {
        this.periodAmt = '';
        this.periodUnit = '';
        this.extperiodEndDate = '';
        this.extperiodStartDate2 = this.addDays(this.oldperiodEndDate,1);
        this.extperiodStartDate1 = '';
      }else if(newval === 2) {
        this.extperiodStartDate2 = '';
        this.extperiodStartDate1 = this.addDays(this.oldperiodEndDate,1);
        this.periodUnit = 'mm';
      }
      Promise.all([
        this.$validator.validate('extperiodStartDate1'),
        this.$validator.validate('extperiodStartDate2'),
        this.$validator.validate('extperiodEndDate'),
      ]);

      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
        periodAmt: this.periodAmt,
        periodUnit: this.periodUnit,
      });
    },
    extperiodStartDate1(newDate, oldDate) {
      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,    
        periodAmt: this.periodAmt,
        periodUnit: this.periodUnit,
      });
    },
    extperiodStartDate2(newDate, oldDate) {
      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
        periodAmt: this.periodAmt,
        periodUnit: this.periodUnit,
      });
    },
    extperiodEndDate(newDate, oldDate) {
      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
        periodAmt: this.periodAmt,
        periodUnit: this.periodUnit,
      });
    }    
  }  
};
</script>